import ReactOnRails from 'react-on-rails/client';
import RatingStars from '../../src/RatingStars/ror_components/RatingStars.client.jsx';

ReactOnRails.register({RatingStars});